import { CommonService } from '@services/common.service';
import { UserService } from '@services/user.service';
import { ErrorResponse } from '@models/error.response';
import { User } from '@models/user';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { AppConstant } from '@constants/app.constant';
import { MainComponent } from '../main/main.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ViewChild, Input, AfterViewInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2'
import { switchMap } from 'rxjs/operators';


declare var jQuery: any;

@Component({
    selector: 'image-preview',
    templateUrl: './image-preview.component.html',
    styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements AfterViewInit {

    @ViewChild('modal', { static: false }) modal: ModalDirective;


    isFieldError = FormValidationUtil.isFieldError;
    loading: boolean = false;
    closeConfig: boolean = false;
    content:string;


    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        public appConstant: AppConstant,
        private commonService: CommonService) {
    }


    ngOnInit(): void {

        this.loading = false;
        this.content = ''


    }

    ngAfterViewInit(): void {


    }

    public open(content:string): void {
        this.ngOnInit();
        this.content = content;
        this.modal.show();
    }

    public close(): void {
        this.modal.hide();
    }

}